import script from "./DecisionSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./DecisionSummary.vue?vue&type=script&setup=true&lang=js"

import "./DecisionSummary.vue?vue&type=style&index=0&id=bfc5c504&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfc5c504"]])

export default __exports__